import React, { useState } from "react";
import fetchData from "../../api/fetchApi";
import { useNavigate } from "react-router-dom";

export default function AddLearnPage() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    title: "",
    local_link: "",
    online_link: "",
    is_active: false,
    category_id: "",
    thumbnail: ""
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(null);
    try {
      const body = {
        ...form,
        is_active: form.is_active ? 1 : 0
      };
      await fetchData("chaat/learns", "POST", body);
      setSuccess("تمت إضافة الدرس بنجاح!");
      setTimeout(() => navigate("/admin/learns"), 1200);
    } catch (err) {
      setError(err.message || "حدث خطأ أثناء الإضافة");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-lg mx-auto p-6 bg-white rounded-2xl shadow">
      <h2 className="text-xl font-bold mb-4">إضافة درس جديد</h2>
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <input
          name="title"
          value={form.title}
          onChange={handleChange}
          className="border rounded px-3 py-2"
          placeholder="عنوان الدرس"
          required
        />
        <input
          name="local_link"
          value={form.local_link}
          onChange={handleChange}
          className="border rounded px-3 py-2"
          placeholder="رابط الفيديو المحلي"
        />
        <input
          name="online_link"
          value={form.online_link}
          onChange={handleChange}
          className="border rounded px-3 py-2"
          placeholder="رابط خارجي (يوتيوب)"
        />
        <input
          name="thumbnail"
          value={form.thumbnail}
          onChange={handleChange}
          className="border rounded px-3 py-2"
          placeholder="رابط الصورة المصغرة"
        />
        <input
          name="category_id"
          value={form.category_id}
          onChange={handleChange}
          className="border rounded px-3 py-2"
          placeholder="رقم التصنيف"
          required
        />
        <label className="flex items-center gap-2">
          <input
            type="checkbox"
            name="is_active"
            checked={form.is_active}
            onChange={handleChange}
          />
          <span>نشط</span>
        </label>
        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded-lg shadow"
          disabled={loading}
        >
          {loading ? "جاري الإضافة..." : "إضافة"}
        </button>
        {error && <div className="text-red-600 text-sm">{error}</div>}
        {success && <div className="text-green-600 text-sm">{success}</div>}
      </form>
    </div>
  );
}
